export default class Field {
  constructor(id, name, component, parentTagClassName, isVisible) {
    this.id = id;
    this.name = name;
    this.component = component;
    this.parentTagClassName = parentTagClassName;
    this.isVisible = isVisible;
  }
}
